export default "__VITE_ASSET__DBEIofJ0__"